var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Web",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M3.9,3.9A11.8,11.8,0,0,1,13,0a11.8,11.8,0,0,1,9.1,3.9A11.8,11.8,0,0,1,26,13a11.8,11.8,0,0,1-3.9,9.1A11.8,11.8,0,0,1,13,26a11.8,11.8,0,0,1-9.1-3.9A12.974,12.974,0,0,1,0,13,11.8,11.8,0,0,1,3.9,3.9ZM14.733,23.4q1.3,0,3.25-1.95A9.463,9.463,0,0,0,19.5,16.9a3.588,3.588,0,0,0-1.083-2.6A3.814,3.814,0,0,0,15.6,13H13.433a6.326,6.326,0,0,1-1.95-.433,1.967,1.967,0,0,1-.65-1.517,1.126,1.126,0,0,1,.433-.867,1.643,1.643,0,0,1,.867-.433,1.479,1.479,0,0,1,1.083.65c.433.217.65.433.867.433a1.3,1.3,0,0,0,.867-.217,1.3,1.3,0,0,0,.217-.867,3.448,3.448,0,0,0-1.083-2.167,8.962,8.962,0,0,0,1.083-4.117.466.466,0,0,0-.433-.433A6.7,6.7,0,0,0,13,2.6,10.838,10.838,0,0,0,7.367,4.333a5.455,5.455,0,0,0-1.95,4.333A5.548,5.548,0,0,0,7.15,12.783a5.919,5.919,0,0,0,4.117,1.733h0v.867a2.782,2.782,0,0,0,.867,2.167,3.155,3.155,0,0,0,1.95,1.3v3.9c0,.217,0,.217.217.433S14.517,23.4,14.733,23.4Z",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.7378c5a3cf293564a01bdf5e3c2b4f2d.svg";
export { ForwardRef as ReactComponent };